<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div>
		<vs-sidebar
			parent="body"
			click-not-close
			position-right
			default-index="1"
			color="primary"
			class="add-new-data-sidebar items-no-padding"
			v-model="isSidebarActive"
		>
			<div class="flex items-center justify-between px-6 p-4" style="background: #eee">
				<h4>{{ $t("Group.CreateGroup") }}</h4>
				<feather-icon icon="XIcon" @click.stop="isSidebarActive = false" class="cursor-pointer"></feather-icon>
			</div>
			<OptimizationGroupCreate @showSidebar="showSidebarEmit" @refreshList="refresh()" />
		</vs-sidebar>
		<vs-sidebar
			v-if="isSidebarEditActive"
			parent="body"
			click-not-close
			position-right
			default-index="1"
			color="primary"
			class="add-new-data-sidebar items-no-padding"
			v-model="isSidebarEditActive"
		>
			<div class="flex items-center justify-between px-6 p-4" style="background: #eee">
				<h4>{{ $t("Group.UpdateGroup") }}</h4>
				<feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
			</div>
			<OptimizationGroupEdit
				:data="getInformationToUpdate"
				@showSidebarEdit="showSidebarEdit"
				@refreshList="refresh()"
			>
			</OptimizationGroupEdit>
		</vs-sidebar>
		<slot></slot>
		<div class="vx-card p-6" :noShadow="customConfig.showPopup">
			<div class="flex flex-wrap items-center justify-end" v-if="customConfig.tableOptions">
				<!-- ITEMS PER PAGE -->
				<div class="flex-grow" v-if="customConfig.showItemsPerPage">
					<vs-dropdown vs-trigger-click class="cursor-pointer">
						<div
							class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
						>
							<span class="mr-2"
								>{{
									paginationPageSize === 0
										? 0
										: currentPage * paginationPageSize - (paginationPageSize - 1)
								}}
								-
								{{
									usersData.length - currentPage * paginationPageSize > 0
										? currentPage * paginationPageSize
										: usersData.length
								}}
								{{ $t("Of") }} {{ pagination.total_records }}</span
							>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<vs-dropdown-menu>
							<vs-dropdown-item @click="paginationSetPageSize(20)">
								<span>20</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="paginationSetPageSize(50)">
								<span>50</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="paginationSetPageSize(100)">
								<span>100</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="paginationSetPageSize(200)">
								<span>200</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>
				<template>
					<!-- ITEMS PER PAGE -->
					<div>
						<vs-dropdown vs-trigger-click class="cursor-pointer">
							<div
								class="p-3 mt-1 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
							>
								<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
								<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
							</div>
							<vs-dropdown-menu>
								<vs-dropdown-item @click="setSearchField('Id')">
									<span>Id</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="setSearchField('Name')">
									<span>{{ $t("Name") }}</span>
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>
				</template>
				<!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
				<vx-tooltip
					class="cursor-pointer md:w-1/3"
					color="primary"
					position="bottom"
					delay=".1s"
					:title="$t('Search')"
					:text="$t('SearchSeparatedByCommas') + '.'"
				>
					<tags-input
						element-id="tags"
						v-model="searchQuery"
						add-tags-on-comma
						add-tags-on-blur
						:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
						:typeahead="true"
						@keyup.enter="search"
					></tags-input>
				</vx-tooltip>
				<vs-button
					class="ml-2"
					color="primary"
					icon-pack="feather"
					icon="icon-search"
					:title="$t('VisitPoints.Search')"
					@click.prevent="search"
				></vs-button>
				<vs-button
					class="ml-2 mr-2"
					color="primary"
					icon-pack="feather"
					icon="icon-refresh-cw"
					:title="$t('Refresh')"
					@click.prevent="refresh()"
				></vs-button>
				<vs-button
					class="mr-2"
					color="primary"
					icon-pack="feather"
					icon="icon-plus"
					:title="$t('Group.AddGroup')"
					@click.prevent="isSidebarActive = true"
				></vs-button>
				<vs-dropdown
					vs-custom-content
					:vs-trigger-click="true"
					class="cursor-pointer"
					:title="$t('Setting.Setting')"
				>
					<vs-button type="filled" icon-pack="feather" icon="icon-settings"></vs-button>
					<vs-dropdown-menu style="z-index: 54000; width: 30%">
						<vx-card no-shadow :title="$t('Setting.Setting')">
							<div class="flex flex-row justify-between p-1">
								<p class="mr-2">{{ $t("Preferences.FindExactly") }}</p>
								<vs-switch color="success" v-model="isExactly" @input="openEnableConfirm"></vs-switch>
							</div>
						</vx-card>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
			<!-- AgGrid Table -->
			<ag-grid-vue
				ref="agGridTable"
				:components="components"
				:gridOptions="gridOptions"
				:style="!customConfig.tableOptions ? 'padding-top: 80px' : ''"
				class="ag-theme-material w-100 my-4 ag-grid-table"
				:class="[{'ag-customizer-container': !isWidthPortatil}]"
				:columnDefs="columnDefs"
				:defaultColDef="defaultColDef"
				:rowData="usersData"
				:rowSelection="customConfig.rowSelection"
				colResizeDefault="shift"
				:animateRows="true"
				:pagination="true"
				:paginationPageSize="paginationPageSize"
				:suppressPaginationPanel="true"
				:enableRtl="$vs.rtl"
				:overlayNoRowsTemplate="overlayNoRowsTemplate"
				:overlayLoadingTemplate="overlayLoadingTemplate"
				:enableCellTextSelection="true"
			>
			</ag-grid-vue>
			<vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
		</div>
	</div>
</template>

<script>
import {optimizationGroupListMixin} from "../model/OptimizationGroupListMixin";

export default {
	mixins: [optimizationGroupListMixin],
};
</script>

<style lang="scss" scoped>
#page-user-list {
	.user-list-filters {
		.vs__actions {
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-58%);
		}
	}
}
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 51010;
		background-color: rgba(0, 0, 0, 0.7);
	}

	::v-deep .vs-sidebar {
		z-index: 51010;
		width: 450px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
</style>
